import React, { useEffect, useState } from "react";
import "./FullScreenButton.css";

const FullScreenButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const configuratorContainer = document.querySelector(
      ".configurator-container"
    );
    const configuratorScene = document.querySelector("#configurator-scene");

    if (configuratorContainer) {
      if (isOpen) {
        configuratorContainer.classList.add("full-screen");
      } else {
        configuratorContainer.classList.remove("full-screen");
      }

      const width = configuratorScene?.getBoundingClientRect().width ?? 800;
      const height = configuratorScene?.getBoundingClientRect().height ?? 800;
      window.APP.resize(width, height);
    }
  }, [isOpen]);

  return (
    <>
      <div
        className={`left-bar-button tooltip-wrapper full-screen-button ${
          isOpen ? "active" : ""
        }`}
        id="iconFullScreen"
        onClick={handleClick}
      >
        <div className="tooltip-text">Volledig scherm</div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
        >
          <g clipPath="url(#a)">
            <path
              fill="currentColor"
              d="M9.707 14.293a.999.999 0 0 1 0 1.414L3.414 22H8a1 1 0 1 1 0 2H3c-1.654 0-3-1.346-3-3v-5a1 1 0 1 1 2 0v4.586l6.293-6.293a.999.999 0 0 1 1.414 0ZM21 0h-5a1 1 0 1 0 0 2h4.586l-6.293 6.293a.999.999 0 1 0 1.414 1.414L22 3.414V8a1 1 0 1 0 2 0V3c0-1.654-1.346-3-3-3Z"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="currentColor" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </>
  );
};

export default FullScreenButton;
